// @ts-nocheck

import { createSelector } from 'reselect';

import { MatchEntity } from '../states/entities/matches';
import { type StateType } from '../states/index';
import { Licences } from '../types/common';
import { type Selector } from '../types/selectors';
import { SportIds } from '../types/sports';

import { type GetOutcomeIdOrOddsIdFromPropsType } from './_propsGetters_';
import { selectEntitiesMatchesEntity } from './entities/matches/entitiesMatchesPrimary.selector';
import { selectMyMatchFutureEntitiesOutcomesEntity } from './mymatch/mymatchPrimary.selector';
import {
  selectRuntimeIsMyMatchBasketballEnabled,
  selectRuntimeIsMyMatchEnabled,
  selectRuntimeIsMyMatchSoccerEnabled,
  selectRuntimeIsMyMatchSoccerLiveEnabled,
  selectRuntimeSiteLicence,
} from './runtime/runtimePrimary.selector';

export const makeMatchIsMyMatchAvailableSelector = () =>
  createSelector(
    [
      selectEntitiesMatchesEntity,
      selectRuntimeSiteLicence,
      selectRuntimeIsMyMatchEnabled,
      selectRuntimeIsMyMatchSoccerEnabled,
      selectRuntimeIsMyMatchSoccerLiveEnabled,
      selectRuntimeIsMyMatchBasketballEnabled,
    ],
    (
      match,
      siteLicence,
      isMyMatchEnabled,
      isMyMatchSoccerEnabled,
      isMyMatchSoccerLiveEnabled,
      isMyMatchBasketballEnabled,
    ) => {
      const isPrematch = MatchEntity.isPrematch(match);

      if (match) {
        const isValid = siteLicence !== Licences.IT && MatchEntity.isMyMatchAvailable(match) && isMyMatchEnabled;

        switch (match.sportId) {
          case SportIds.SOCCER:
            if (isPrematch) {
              return isValid && isMyMatchSoccerEnabled;
            }
            return isValid && isMyMatchSoccerLiveEnabled;
          case SportIds.BASKETBALL:
            return isValid && isMyMatchBasketballEnabled;
          default:
            return MatchEntity.isMyMatchAvailable(match);
        }
      }

      return false;
    },
  );

// no-memoize
export const selectMyMatchFutureEntitiesOutcomesEntityAvailable: Selector<boolean> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => !!selectMyMatchFutureEntitiesOutcomesEntity(state, props);
